<app-layout-dialogheader1 [title]="'Change Status for supervision: ' + supervision?.name" [titlesub]="''" mat-dialog-title></app-layout-dialogheader1>
<mat-dialog-content>
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <div class="custom-control custom-radio statusitem" >
      <mat-radio-group [(ngModel)]="statusselected">
        <mat-radio-button [value]="item.id" *ngFor="let item of statuslist">{{item.name}}</mat-radio-button>        
      </mat-radio-group>
    </div>



</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end mat-dialog-actions">
    <button mat-raised-button type="button" class="btn btn-success pull-right" (click)="save()" [disabled]="submitted">Save</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>

